module.exports = __webpack_public_path__ + "img/progress_3.2b697801.png";